import { Text } from '@sparemin/blockhead';
import React from 'react';
import { formatDurationMillis, secToMillis } from 'utils/time';
import { block } from '../../utils';

export type EditScenePreviewPlaybackTimeProps = {
  currentTime: number;
  duration: number;
};

const formatTime = (time: number) =>
  formatDurationMillis(secToMillis(time), {
    minute: 'numeric',
    second: '2-digit',
    trim: false,
  });

const EditScenePreviewPlaybackTime: React.FC<EditScenePreviewPlaybackTimeProps> = ({
  currentTime,
  duration,
}) => {
  // prevent negatives while the UI settles
  const displayCurrentTime = Math.max(currentTime, 0);

  return (
    <div className={block('preview-playbar-playback-time')}>
      <Text variant="mono">
        {formatTime(displayCurrentTime)}
        <span className={block('preview-playbar-playback-time-separator')}>
          /
        </span>
        {formatTime(duration)}
      </Text>
    </div>
  );
};

export default EditScenePreviewPlaybackTime;
